export default {"src":"/_next/static/media/thehomedepot.d4bacb40.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};